export const FRAME_ID = 'hosted-fields-frame';
export const FRAME_HEIGHT = 270;
